import { centerBlockStyle } from "../../styles/styles";

export const Unavailable = () => {
  return (
    <div style={centerBlockStyle}>
      <h1>Доступ заборонено</h1>
    </div>
  );
};
